<template>
  <div class="rechargeList-box">
    <!--操作栏-->
    <div class="action-bar">
      订单时间:
      <el-select
        placeholder="请选择订单时间"
        size="small"
        clearable
        v-model="params.timeString"
        @change="getOrderList('status')"
      >
        <el-option
          v-for="item in orderTime"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>渠道:
      <el-input
        v-model="params.channel"
        placeholder="请输入渠道号"
        size="small"
        class="param-input"
        clearable
        @keyup.enter.native="getOrderList('status')"
      ></el-input><el-input
        v-model="params.districtCode"
        placeholder="请输入渠道推广码"
        size="small"
        class="param-input"
        clearable
        @keyup.enter.native="getOrderList('status')"
      ></el-input>商户ID:
      <el-input
        v-model="params.traderId"
        placeholder="请输入商户ID"
        size="small"
        class="param-input"
        clearable
        @keyup.enter.native="getOrderList('status')"
      ></el-input>状态:
      <el-select
        placeholder="支付状态"
        size="small"
        clearable
        v-model="params.status"
        @change="getOrderList('status')"
      >
        <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>设备:
      <el-select
        placeholder="设备类型"
        size="small"
        clearable
        v-model="params.devType"
        @change="getOrderList('status')"
      >
        <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-input
        v-model="params.oid"
        placeholder="请输入支付平台订单号"
        size="small"
        class="param-input"
        clearable
        @keyup.enter.native="getOrderList('status')"
      ></el-input>
      <el-input
        v-model="params.id"
        placeholder="请输入订单ID"
        size="small"
        class="param-input"
        clearable
        @keyup.enter.native="getOrderList('status')"
      ></el-input>
      <el-input
        v-model="params.uid"
        placeholder="请输入用户ID"
        size="small"
        class="param-input"
        clearable
        @keyup.enter.native="getOrderList('status')"
      ></el-input>
      <el-select
        placeholder="充值类型"
        size="small"
        clearable
        v-model.trim="params.rechargeType"
        @change="getOrderList('status')"
      >
        <el-option
          v-for="(item,i) in rechargeType"
          :key="i"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="订单类型"
        size="small"
        clearable
        v-model.trim="params.productType"
        @change="getOrderList('status')"
      >
        <el-option
          v-for="(item,i) in productType"
          :key="i"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        @change="changeTime"
      ></el-date-picker>
      <el-button type="primary" size="small" @click="getOrderList('status')">搜索</el-button>
      <el-button type="primary" size="small" @click="rechargeOrderExport">导出</el-button>
    </div>

    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      @sort-change="handleSortChange"
      height="590"
    >
      <el-table-column prop="id" label="订单id" align="center" width="240" fixed>
        <template slot-scope="scope">
          <span>{{scope.row.id || '无'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="oid" label="支付平台订单号" align="center" width="240" fixed>
        <template slot-scope="scope">
          <span>{{scope.row.oid || '无'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="traderId" label="商户ID" align="center" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.traderId || '无'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" align="center" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.uid || '无'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="districtCode" label="渠道推广码" align="center" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.districtCode || '无'}}</span>
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="productID" label="产品ID" align="center" width="220">
        <template slot-scope="scope">
          <span>{{scope.row.productID || '未知'}}</span>
        </template>
      </el-table-column>
      -->
      <el-table-column
        prop="remark"
        label="订单说明"
        align="center"
        width="200"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{scope.row.remark || '暂无说明'}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="productType"
        label="订单类型"
        align="center"
        width="200"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{scope.row.productType | productType}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="channel" label="支付渠道" align="center" width="220">
        <template slot-scope="scope">
          <div class="channel-switch">
            <div class="channel-item">
              <span>{{scope.row.channel }}</span>
            </div>
            <!-- <div class="daichong" v-if="scope.row.channel ==='daichong'">
              <div style="font-size:14px;font-weight:700">回调第三方:<span :style="{color:(scope.row.notifyStatus===1)?'#44ee0d':'#b1254a'}">{{scope.row.notifyStatus | filterNotifyStatus}}</span></div>
              <div v-if="!(scope.row.notifyStatus===1)">
                <el-button type="danger" size="mini" plain="" @click="handleClickNotifyStatus(scope.row.oid)">通知第三方</el-button>
              </div>
            </div>-->
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="devType" label="设备类型" align="center" width="120">
        <template slot-scope="scope">
          <span>{{scope.row.devType || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="money" label="订单金额(元)" align="center" width="140" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{(scope.row.money/100 || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="payMoney"
        label="实付金额(元)"
        align="center"
        width="140"
        :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{(scope.row.payMoney/100 || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="120">
        <template slot-scope="scope">{{scope.row.status | orderStatus}}</template>
      </el-table-column>
      <el-table-column
        prop="statusDesc"
        label="状态说明"
        align="center"
        width="300"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{scope.row.statusDesc || '暂无说明'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" align="center" width="200">
        <template slot-scope="scope">
          <span>{{scope.row.updatedAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" width="200">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="paymentAt" label="支付时间" align="center" width="200">
        <template slot-scope="scope">
          <span>{{scope.row.paymentAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="successAt" label="回调时间" align="center" width="200">
        <template slot-scope="scope">
          <span>{{scope.row.successAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="proof" label="交易凭证" align="center" width="100">
        <template slot-scope="scope">
          <decrypt-img
            style="width: 50px; height: 50px"
            :src="scope.row.proof"
            fit="fit"
          >
            <div slot="error" class="image-slot">无图片</div>
          </decrypt-img>
          
        </template> 
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="330">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="editDesc(scope.row)"></el-button>
          <!-- <el-button type="success" size="mini" icon="el-icon-edit" @click="editDesc(scope.row)">通知第三方平台</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 15, 20, 25]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 10"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <edit-desc ref="editDesc" @handlerEdit="getOrderList()"></edit-desc>
  </div>
</template>
<script>
import baseConfig from "@/utils/serverUrlConfig";
import { paramsFilter } from "@/utils/global";
import { sortEscape, changeTime } from "@/utils/global";
import editDesc from "./components/edit-desc";
import API from "@/api";
export default {
  data() {
    return {
      tableData: [],
      time: "",
      loading: false,
      total: 0,
      rechargeType: [
        { label: "微信", value: "wechat" },
        { label: "支付宝", value: "alipay" },
        { label: "代充", value: "daichong" },
      ],
      productType: [
        { label: "全部", value: '' },
        { label: "站群订单", value: 0 },
        { label: "棋牌订单", value: 1 }
      ],
      // 订单时间选择
      orderTime: [
        {
          label: "创建时间",
          value: "createdAt",
        },
        {
          label: "支付时间",
          value: "paymentAt",
        },
        {
          label: "回调时间",
          value: "successAt",
        },
      ],
      // 订单状态下拉数据
      status: [
        {
          label: "进行中",
          value: 1,
        },
        {
          label: "付款失败",
          value: 2,
        },
        {
          label: "付款成功",
          value: 3,
        },
        {
          label: "已退款",
          value: 4,
        },
      ],
      type: [
        {
          label: "ios",
          value: "ios",
        },
        {
          label: "pc",
          value: "pc",
        },
        {
          label: "android",
          value: "android",
        },
      ],
      // 请求订单列表参数
      params: {
        pageNumber: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        sortKey: "",
        sortValue: "",
        channel: "",
        id: "",
        oid: "",
        uid: "",
        status: "",
        devType: "",
        timeString: "",
        rechargeType: "",
        traderId: "",
        districtCode: "",
      },
    };
  },
  filters: {
    filterNotifyStatus(params) {
      switch (params) {
        case 0:
          return "未通知";
        case 1:
          return "成功";
        case 2:
          return "失败";
      }
    },
    productType(params) {
      switch (params) {
        case 0:
          return '站群订单';
        case 1:
          return '棋牌订单';
      }
    }
  },
  components: {
    editDesc,
  },
  created() {
    this.getOrderList();
  },
  methods: {
    /**
     * 点击通知第三方
     */
    // async handleClickNotifyStatus(id) {
    //   this.$confirm("确定要通知第三方嘛？", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   })
    //     .then(() => {
    //       this.httpHandAddScore(id);
    //     })
    //     .catch(() => {
    //       window.console.log("取消");
    //     });
    // },
    async httpHandAddScore(id) {
      try {
        const data = await API.handAddScore({ oid: id });
        if (data.code === 200) {
          this.$message.success("以通知第三方");
          this.getOrderList();
        }
      } catch (err) {
        this.$message.error("通知第三方失败");
        this.getOrderList();
      }
    },
    // 请求订单列表
    getOrderList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      API.getOrderList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data.orders) {
            this.tableData = res.data.orders;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 充值订单导出
    rechargeOrderExport() {
      let params = paramsFilter(this.params);
      let str = "";
      for (let key in params) {
        if (key == "startTime" || key == "endTime") {
          params[key] = params[key].replace("+", "%2B");
        }
        str += key + "=" + params[key] + "&";
      }
      str = str.substring(0, str.length - 1);
      let url = baseConfig.baseServerUrl + "/export/rechargeOrder?" + str;
      window.location.href = url;
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size;
      this.getOrderList();
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getOrderList();
    },
    // 数据排序
    handleSortChange(column) {
      if (column.order) {
        this.params.sortValue = sortEscape(column.order);
        this.params.sortKey = column.prop;
      } else {
        this.params.sortValue = "";
        this.params.sortKey = "";
      }
      this.getOrderList();
    },
    // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.params.startTime = changeTime(time[0]) || "";
        this.params.endTime = changeTime(time[1]) || "";
      } else {
        this.params.startTime = "";
        this.params.endTime = "";
      }
      this.getOrderList("status");
    },
    // 新增、删除tags
    editDesc(data) {
      this.$refs.editDesc.open(data);
    },
  },
};
</script>
<style lang="scss">
.rechargeList-box {
  .icon {
    font-size: 16px;
    margin-left: 10px;
    cursor: pointer;
    color: #e63765;
    vertical-align: middle !important;
    &:hover {
      color: #eb5f84;
    }
  }
  .channel-switch {
    display: flex;
    -ms-flex-direction: row;
    flex-direction: row;
    justify-content: center;
    .channel-item {
      flex: 1;
    }
    .daichong {
      flex: 2;
    }
  }
}
</style>

